import { render, staticRenderFns } from "./FlashCardView.vue?vue&type=template&id=62fb1fcd&scoped=true&"
import script from "./FlashCardView.vue?vue&type=script&lang=js&"
export * from "./FlashCardView.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardView.vue?vue&type=style&index=0&id=62fb1fcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb1fcd",
  null
  
)

export default component.exports